/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';
import type { ApiSanctionType } from './ApiSanctionType';
import {
    ApiSanctionTypeFromJSON,
    ApiSanctionTypeFromJSONTyped,
    ApiSanctionTypeToJSON,
    ApiSanctionTypeToJSONTyped,
} from './ApiSanctionType';
import type { ApiSanctionEntity } from './ApiSanctionEntity';
import {
    ApiSanctionEntityFromJSON,
    ApiSanctionEntityFromJSONTyped,
    ApiSanctionEntityToJSON,
    ApiSanctionEntityToJSONTyped,
} from './ApiSanctionEntity';
import type { ApiSanctionAlertStatusEvent } from './ApiSanctionAlertStatusEvent';
import {
    ApiSanctionAlertStatusEventFromJSON,
    ApiSanctionAlertStatusEventFromJSONTyped,
    ApiSanctionAlertStatusEventToJSON,
    ApiSanctionAlertStatusEventToJSONTyped,
} from './ApiSanctionAlertStatusEvent';
import type { ApiSanctionHit } from './ApiSanctionHit';
import {
    ApiSanctionHitFromJSON,
    ApiSanctionHitFromJSONTyped,
    ApiSanctionHitToJSON,
    ApiSanctionHitToJSONTyped,
} from './ApiSanctionHit';
import type { ApiMatchSource } from './ApiMatchSource';
import {
    ApiMatchSourceFromJSON,
    ApiMatchSourceFromJSONTyped,
    ApiMatchSourceToJSON,
    ApiMatchSourceToJSONTyped,
} from './ApiMatchSource';
import type { ApiAlertAssignment } from './ApiAlertAssignment';
import {
    ApiAlertAssignmentFromJSON,
    ApiAlertAssignmentFromJSONTyped,
    ApiAlertAssignmentToJSON,
    ApiAlertAssignmentToJSONTyped,
} from './ApiAlertAssignment';

/**
 * a Sanction Alert
 * @export
 * @interface ApiSanctionAlert
 */
export interface ApiSanctionAlert {
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionAlert
     */
    id: number;
    /**
     * 
     * @type {ApiSanctionEntity}
     * @memberof ApiSanctionAlert
     */
    entity: ApiSanctionEntity;
    /**
     * 
     * @type {Date}
     * @memberof ApiSanctionAlert
     */
    createdTime: Date;
    /**
     * 
     * @type {Array<ApiSanctionHit>}
     * @memberof ApiSanctionAlert
     */
    matches?: Array<ApiSanctionHit>;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiSanctionAlert
     */
    assignee?: ApiAssignmentUser;
    /**
     * 
     * @type {Array<ApiAlertAssignment>}
     * @memberof ApiSanctionAlert
     */
    assignments?: Array<ApiAlertAssignment>;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionAlert
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionAlert
     */
    statusId: number;
    /**
     * 
     * @type {Array<ApiSanctionAlertStatusEvent>}
     * @memberof ApiSanctionAlert
     */
    statuses?: Array<ApiSanctionAlertStatusEvent>;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionAlert
     * @deprecated
     */
    fieldKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiSanctionAlert
     */
    isGoodlistable?: boolean;
    /**
     * 
     * @type {ApiSanctionType}
     * @memberof ApiSanctionAlert
     */
    type: ApiSanctionType;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionAlert
     */
    customListId?: string;
    /**
     * 
     * @type {Array<ApiMatchSource>}
     * @memberof ApiSanctionAlert
     */
    matchSources?: Array<ApiMatchSource>;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionAlert
     */
    screeningFlowId: string;
}



/**
 * Check if a given object implements the ApiSanctionAlert interface.
 */
export function instanceOfApiSanctionAlert(value: object): value is ApiSanctionAlert {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entity' in value) || value['entity'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('screeningFlowId' in value) || value['screeningFlowId'] === undefined) return false;
    return true;
}

export function ApiSanctionAlertFromJSON(json: any): ApiSanctionAlert {
    return ApiSanctionAlertFromJSONTyped(json, false);
}

export function ApiSanctionAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entity': ApiSanctionEntityFromJSON(json['entity']),
        'createdTime': (new Date(json['createdTime'])),
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(ApiSanctionHitFromJSON)),
        'assignee': json['assignee'] == null ? undefined : ApiAssignmentUserFromJSON(json['assignee']),
        'assignments': json['assignments'] == null ? undefined : ((json['assignments'] as Array<any>).map(ApiAlertAssignmentFromJSON)),
        'status': json['status'],
        'statusId': json['statusId'],
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(ApiSanctionAlertStatusEventFromJSON)),
        'fieldKey': json['fieldKey'] == null ? undefined : json['fieldKey'],
        'isGoodlistable': json['isGoodlistable'] == null ? undefined : json['isGoodlistable'],
        'type': ApiSanctionTypeFromJSON(json['type']),
        'customListId': json['customListId'] == null ? undefined : json['customListId'],
        'matchSources': json['matchSources'] == null ? undefined : ((json['matchSources'] as Array<any>).map(ApiMatchSourceFromJSON)),
        'screeningFlowId': json['screeningFlowId'],
    };
}

export function ApiSanctionAlertToJSON(json: any): ApiSanctionAlert {
    return ApiSanctionAlertToJSONTyped(json, false);
}

export function ApiSanctionAlertToJSONTyped(value?: ApiSanctionAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entity': ApiSanctionEntityToJSON(value['entity']),
        'createdTime': value['createdTime'].toISOString(),
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(ApiSanctionHitToJSON)),
        'assignee': ApiAssignmentUserToJSON(value['assignee']),
        'assignments': value['assignments'] == null ? undefined : ((value['assignments'] as Array<any>).map(ApiAlertAssignmentToJSON)),
        'status': value['status'],
        'statusId': value['statusId'],
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(ApiSanctionAlertStatusEventToJSON)),
        'fieldKey': value['fieldKey'],
        'isGoodlistable': value['isGoodlistable'],
        'type': ApiSanctionTypeToJSON(value['type']),
        'customListId': value['customListId'],
        'matchSources': value['matchSources'] == null ? undefined : ((value['matchSources'] as Array<any>).map(ApiMatchSourceToJSON)),
        'screeningFlowId': value['screeningFlowId'],
    };
}

